import type { RunMetricsResponse } from '@/entities/run/domain/runManagementTypes';

import { mapRunMetricsResponseToExecutionModalMetrics } from './mapRunMetricsResponse';

/**
 * 워크벤치 데모 store(`experimentMockStore`)의 `createDemoExecutionMetrics` +
 * `toMetricHistory`와 동일 규칙으로 최종값·시계열(step 0→2)을 만듭니다.
 * 백엔드 sync/metrics 장애 시 실행 결과 모달에 넣습니다.
 */
function createFallbackFinalMetrics(seedRunId?: number): Record<string, number> {
  const seed = seedRunId != null && Number.isFinite(seedRunId) ? seedRunId : 300;
  const offset = (seed % 17) / 1000;

  return {
    accuracy: Number((0.935 + offset).toFixed(6)),
    loss: Number((0.122 - offset / 2).toFixed(6)),
    f1_score: Number((0.918 + offset).toFixed(6)),
    precision: Number((0.927 + offset).toFixed(6)),
    recall: Number((0.91 + offset).toFixed(6)),
    train_mse_loss: Number((0.084 - offset / 3).toFixed(6)),
  };
}

function buildFallbackMetricHistory(
  metrics: Record<string, number>
): Record<string, Array<{ step: number; value: number }>> {
  return Object.fromEntries(
    Object.entries(metrics).map(([name, value]) => {
      const firstValue = Number((value * 0.72).toFixed(6));
      const secondValue = Number((value * 0.9).toFixed(6));
      return [
        name,
        [
          { step: 0, value: firstValue },
          { step: 1, value: secondValue },
          { step: 2, value },
        ],
      ];
    })
  );
}

export function getFallbackExecutionResultModalMetrics(
  seedRunId?: number
): ReturnType<typeof mapRunMetricsResponseToExecutionModalMetrics> {
  const final = createFallbackFinalMetrics(seedRunId);
  const payload: RunMetricsResponse = {
    sourceRunId: String(seedRunId ?? 'offline'),
    final,
    history: buildFallbackMetricHistory(final),
  };
  return mapRunMetricsResponseToExecutionModalMetrics(payload);
}
